import React from "react"; // eslint-disable-line no-unused-vars
import { Button } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";

export interface SignInLinkProps {
  disabled?: boolean;
  label?: string;
}

export const SignInLink = ({
  disabled = false,
  label = "Sign In",
}: SignInLinkProps): React.JSX.Element | null => {
  const { isAuthenticated, loginWithPopup } = useAuth0();

  if (isAuthenticated) {
    return null;
  } else {
    return (
      <Button
        sx={{ display: "inline-block", margin: "8px" }}
        variant="outlined"
        className="tb_secondary_button"
        onClick={() => {
          if (!disabled) {
            loginWithPopup();
          }
        }}
      >
        {label}
      </Button>
    );
  }
};
